// src/features/geospatial/components/ZoneToolbar.jsx

import { Paper, Stack, IconButton, Tooltip } from "@mui/material";

import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MyLocationIcon from "@mui/icons-material/MyLocation";

export default function ZoneToolbar({
  mode,
  onDrawMode,
  onMoveMode,
  onClearMap,
  onPreviewH3,
}) {
  return (
    <Paper
      elevation={4}
      sx={{
        position: "absolute",
        top: 20,
        left: 20,
        zIndex: 1000,
        borderRadius: 3,
        p: 1,
      }}
    >
      <Stack direction="row" spacing={1}>
        <Tooltip title="Dibujar zona">
          <IconButton
            color={mode === "draw" ? "primary" : "default"}
            onClick={onDrawMode}
          >
            <EditLocationAltIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Mover mapa">
          <IconButton
            color={mode === "move" ? "primary" : "default"}
            onClick={onMoveMode}
          >
            <PanToolAltIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Limpiar polígono">
          <IconButton color="error" onClick={onClearMap}>
            <DeleteOutlineIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Vista previa H3">
          <IconButton color="success" onClick={onPreviewH3}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      </Stack>
    </Paper>
  );
}
